// AI Generated Component
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GlobalPolicyExchangeCenterTemplateService } from '@client/app/modules/global-policy/services/global-policy-exchange-center-template.service';

@Component({
    selector: 'policy-exchange-center-views-grid',
    standalone: false,
    template: `
        <div *ngIf="templates.length === 0">
            <h3 class="font-weight-300 text-grey text-center my-8"
                [attr.aria-label]="'No content was found' | translate"
                translate>
                No content was found
            </h3>
        </div>
        <div class="policy-exchange-center-views-grid row align-items-stretch" *ngIf="templates.length > 0">
            <div class="col-48 col-sm-24 col-md-16 col-lg-12 mb-4" *ngFor="let template of templates; trackBy: trackByIndex">
                <div class="card panel-template-policy max-height d-flex flex-column justify-content-between mb-0">
                    <div class="card-header position-relative d-flex align-items-center pr-8">
                        <span class="badge-new bg-purple d-flex align-items-center justify-content-center" *ngIf="template.new" translate>New</span>
                        <span *ngIf="template.icon" class="grid-icon fa-2x mr-2" [ngClass]="template.icon"></span>
                        <h4 data-test="policy-name" class="card-title">{{ template.name }}</h4>
                    </div>
                    <div class="card-body position-relative flex-fill d-flex flex-wrap">
        <!--                TODO: Reimplement Region & Vertical https://zube.io/monsido/monsido/c/21967 -->
        <!--                <span class="country d-flex align-items-center justify-content-center"-->
        <!--                      *ngFor="let country of template.country; trackBy: trackByIndex"-->
        <!--                      ngbTooltip="{{getCountryDescription(country)}}"-->
        <!--                      [triggers]="'focus hover'"-->
        <!--                      [tooltipClass]="'text-ellipsis'"-->
        <!--                      [placement]="'bottom'"-->
        <!--                      translate>-->
        <!--                    <span class="fa-stack fa-2x">-->
        <!--                      <span class="fas fa-circle fa-stack-2x text-link"></span>-->
        <!--                      <span class="fa-stack-1x fa-inverse" [ngClass]="getCountryIcon(country)"></span>-->
        <!--                    </span>-->
        <!--                </span>-->
        <!--                <span class="fa-stack fa-lg"-->
        <!--                      *ngFor="let vertical of template.vertical; trackBy: trackByIndex"-->
        <!--                      ngbTooltip="{{getVerticalDescription(vertical)}}"-->
        <!--                      [triggers]="'focus hover'"-->
        <!--                      [tooltipClass]="'text-ellipsis'"-->
        <!--                      [placement]="'bottom'">-->
        <!--                    <span class="fas fa-circle fa-stack-2x" [ngClass]="getVerticalBackground(vertical)"></span>-->
        <!--                    <span class="fa-stack-1x"-->
        <!--                          [ngClass]="[getVerticalColor(vertical), getVerticalIcon(vertical)]">-->
        <!--                    </span>-->
        <!--                </span>-->
                    </div>
                    <div class="card-footer bg-white">
                        <button data-test="add-policy-button"
                                type="button"
                                class="btn btn-border-radius btn-marine-blue"
                                (click)="selectTemplate(template)" translate>
                            Add Policy
                        </button>
                    </div>
                </div>
            </div>
        </div>
    `,
})
export class PolicyExchangeCenterViewsGridComponent {
    @Input() templates: any[] = [];
    @Output() chooseTemplate = new EventEmitter<any>();

    constructor (private globalPolicyExchangeCenterTemplateService: GlobalPolicyExchangeCenterTemplateService) {}

    selectTemplate (template: any): void {
        this.chooseTemplate.emit({ template: { ...template } });
    }

    getSubjectIcon (subject: any): any {
        return this.globalPolicyExchangeCenterTemplateService.getSubjectIcon(subject);
    }

    getVerticalIcon (vertical: any): any {
        return this.globalPolicyExchangeCenterTemplateService.getVerticalIcon(vertical);
    }

    getVerticalDescription (vertical: any): any {
        return this.globalPolicyExchangeCenterTemplateService.getVerticalDescription(vertical);
    }

    getVerticalBackground (vertical: any): any {
        return this.globalPolicyExchangeCenterTemplateService.getVerticalBackground(vertical);
    }

    getVerticalColor (vertical: any): any {
        return this.globalPolicyExchangeCenterTemplateService.getVerticalColor(vertical);
    }

    getCountryIcon (country: any): any {
        return this.globalPolicyExchangeCenterTemplateService.getCountryIcon(country);
    }

    getCountryDescription (country: any): any {
        return this.globalPolicyExchangeCenterTemplateService.getCountryDescription(country);
    }

    trackByIndex (index: number): number {
        return index;
    }
}
